/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceAssessmentHistoryBatchRequest {
    getFixupPrototypeFunction() { return ComplianceAssessmentHistoryBatchRequest.fixupPrototype; }

    static newInstance(model: Partial<ComplianceAssessmentHistoryBatchRequest>): ComplianceAssessmentHistoryBatchRequest {
        let obj = Object.assign(new ComplianceAssessmentHistoryBatchRequest(), model);
        ComplianceAssessmentHistoryBatchRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceAssessmentHistoryBatchRequest>): ComplianceAssessmentHistoryBatchRequest {
        if (!model) return null;
        return ComplianceAssessmentHistoryBatchRequest.newInstance(<ComplianceAssessmentHistoryBatchRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceAssessmentHistoryBatchRequest) {
        if (!obj) return;

        models.ComplianceAssessmentHistoryBatchRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceAssessmentHistoryBatchRequest): boolean {
        Object.setPrototypeOf(obj, ComplianceAssessmentHistoryBatchRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    compliance_assessment_history_ids: Array<string>;

    assessment_job_numbers: Array<string>;

}
